import type PlainDate from '@Domain/PlainDate';

/**
 * Generic over `T` rather than `BeneficiaryFormData` itself, so the FormData never has to import
 * its own constraint back (`guides/forms.md` §1.1). A future date yields a negative `ageInYears`, which
 * is what this constraint actually tests for.
 */
function isBirthDateNotInTheFuture<T>(value: PlainDate | null, _formData: T): boolean {
	if (value === null) {
		return true;
	}

	return value.ageInYears() >= 0;
}

export default isBirthDateNotInTheFuture;
